import React from "react";
import { Text, View, Platform, StyleSheet } from "react-native";

import AppTheme from "../../AppTheme";
import appStyles from "../../../appStyles";

export default function Integrationscount({ count }) {
  const color = count >= 3 ? "#23D7C1" : count == 0 ? "#DD5F43" : "#F6EC91";
  const widths = [5, 25, 45, 65, 85, 100];
  let width = widths[Math.min(count, widths.length - 1)];
  const text =
    count == 0
      ? "You’re unlikely to get the best insights. Try connecting to some apps below for a better experience!"
      : count >= 3
      ? `You’re likely to get great insights from automatic time tracking! Let us know what other apps you use below.`
      : "You’ll get some insights with these integrations. Try connecting to more apps for a better experience!";

  return (
    <View style={[styles.container, appStyles.borderBottom]}>
      <Text style={styles.headerText}>Integration health</Text>
      <View style={styles.progress}>
        <View
          style={[
            styles.complete,
            { width: `${width}%`, backgroundColor: color },
          ]}
        />
      </View>
      <Text style={styles.description}>{text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 8,
    paddingBottom: 5,
  },
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 8,
  },
  description: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-Italic" }),
    fontStyle: "italic",
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  progress: {
    position: "relative",
    height: 4,
    width: "100%",
    backgroundColor: "#DADADA",
    borderRadius: 3,
    marginBottom: 4,
  },
  complete: {
    position: "absolute",
    left: 0,
    top: 0,
    height: 4,
    width: "100%",
    borderRadius: 3,
  },
});
